// src/helpers.ts
var objectKeys = Object.keys;
var objectValues = Object.values;
var objectEntries = Object.entries;
function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function arNumsToEn(text) {
  return text.replace(/[٠١٢٣٤٥٦٧٨٩]/g, (d) => "0123456789"[d.charCodeAt(0) - 1632]);
}
function convertArToEn(fn) {
  return (text) => {
    fn(arNumsToEn(text));
  };
}
function bytesToMB(bytes) {
  const bytesPerMB = 1024 * 1024;
  return bytes / bytesPerMB;
}
function convertNumberToLanguage(input, lang) {
  if (lang === "en") return input.toString();
  const num = typeof input === "number" ? input.toString() : input;
  return num.replace(/[0-9]/g, (d) => "\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669"[Number.parseInt(d, 10)]);
}
function normalizePrice(price) {
  return Math.round(price * 100) / 100;
}
function columize(arr, columns) {
  if (columns <= 0) throw new Error("Number of columns must be greater than 0");
  const result = [];
  for (let i = 0; i < arr.length; i += columns) {
    result.push(arr.slice(i, i + columns));
  }
  return result;
}
function pointInPolygon({ x, y }, poly) {
  let inside = false;
  for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
    const { x: xi, y: yi } = poly[i];
    const { x: xj, y: yj } = poly[j];
    const determinant = (yi - yj) * (x - xi) - (xi - xj) * (y - yi);
    if (yj < yi) {
      if (y >= yj && y < yi) {
        if (determinant === 0) return true;
        if (determinant > 0) {
          const prevY = poly[j === 0 ? poly.length - 1 : j - 1].y;
          if (y === yj && y > prevY) inside = !inside;
          else inside = !inside;
        }
      }
    } else if (yi < yj) {
      if (y > yi && y <= yj) {
        if (determinant === 0) return true;
        if (determinant < 0) {
          const prevY = poly[j === 0 ? poly.length - 1 : j - 1].y;
          if (y === yj && y < prevY) inside = !inside;
          else inside = !inside;
        }
      }
    } else if (y === yi && (x >= xj && x <= xi || x >= xi && x <= xj)) {
      return true;
    }
  }
  return inside;
}
function formatWeight(value, kgLabel, gmsLabel) {
  if (value >= 1e3) {
    return `${value / 1e3} ${kgLabel}`;
  }
  return `${value} ${gmsLabel}`;
}

export {
  objectKeys,
  objectValues,
  objectEntries,
  capitalize,
  convertArToEn,
  bytesToMB,
  convertNumberToLanguage,
  normalizePrice,
  columize,
  pointInPolygon,
  formatWeight
};
